export default __webpack_public_path__ + "static/media/404error.a421309b.png";